// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_oh-0";
export var animationContainer = "_oh-1";
export var itemPrice = "_oh-a";
export var itemizedContent = "_oh-9";
export var itemizedHeader = "_oh-7";
export var itemizedRow = "_oh-8";
export var itemizedSection = "_oh-6";
export var modalContent = "_oh-2";
export var orderName = "_oh-3";
export var refundOption = "_oh-4";
export var refundOptionsContainer = "_oh-5";
export var shippingLabel = "_oh-b";
export var totalRow = "_oh-c";